<template>
  <div>
    <v-card class="card-shadow border-radius-xl pa-6">
      <v-row>
        <v-col cols="6">
          <div class="pb-4">
            <h6 class="mb-1 text-typo text-h6 font-weight-bold">
              Liste des parkings
            </h6>
            <p class="text-sm text-body">
              Ajouter, supprimer ou modifier les parking clients et leurs places
            </p>
          </div>
        </v-col>
        <v-col cols="4">
          <SearchField @search="searchUpdate"></SearchField>
        </v-col>
        <v-col cols="2">
          <v-dialog v-model="dialog" width="800">
            <template v-slot:activator="{ on, attrs }">
              <BtnBlue
                :btnTitle="$t('appButton.add')"
                v-bind="attrs"
                v-on="on"
                @clicked="dialog = !dialog"
              ></BtnBlue>
            </template>
            <ParkingForm @closeDialog="dialog = false"></ParkingForm>
          </v-dialog>
        </v-col>
      </v-row>
      <ParkingListTable :dataset="filteredParkingList"></ParkingListTable>
    </v-card>
  </div>
</template>

<script>
import SearchField from "../common/SearchField.vue";
import ParkingListTable from "../Parkings/ParkingListTable.vue";
import ParkingForm from "./ParkingForm.vue";
import BtnBlue from "../common/BtnBlue.vue";

export default {
  name: "ParkingList",

  components: {
    SearchField,
    ParkingListTable,
    BtnBlue,
    ParkingForm,
  },

  props: {
    parkingList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      search: "",
      dialog: false,
    };
  },

  computed: {
    filteredParkingList() {
      const dataToScan = ["name", "address", "city"];
      if (this.search === "") return this.parkingList;
      return this.parkingList.filter((elm) => {
        return dataToScan.some((k) => {
          const search = this.search.toLowerCase();
          return elm[k] && String(elm[k]).toLowerCase().includes(search);
        });
      });
    },
  },

  methods: {
    searchUpdate(e) {
      this.search = e;
    },
  },
};
</script>

<style scoped></style>
